<template>
  <span
    class="time-off-request-bamboo-hr-badge time-off-request-bamboo-hr-badge--calendar"
    data-testid="time-off-request-bamboo-hr-badge"
    aria-hidden="true"
  >
    <img
      :src="IMAGE_BAMBOO_HR_BADGE"
      alt=""
      class="time-off-request-bamboo-hr-badge__img"
      aria-hidden="true"
    >
  </span>
</template>

<script>
import { IMAGE_BAMBOO_HR_BADGE } from '~/rails_assets';

export default {
  name: 'TimeOffRequestBambooHrBadge',
  data() {
    return {
      IMAGE_BAMBOO_HR_BADGE,
    };
  },
};
</script>
